/* This is the EMIS water source components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 61px" border="1px;" width="800" cellspacing="0px;">
        <tbody>
          <tr>
            <td class="row-data">ប្រភពទឹកចម្បង</td>
            <td class="row-data">ប្រើសម្រាប់ផឹក</td>
            <td class="row-data">អាចរកបាននៅថ្ងៃនេះនៅបរិវេណសាលារៀន</td>
            <td class="row-data">ប្រើសម្រាប់គោលបំណងផ្សេង</td>
          </tr>
          <tr v-for="(value, index) in water.length" :key="index">
            <td class="row-data-left">
              {{ water[index] }}
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[index].dt[0]"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, index)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[index].dt[1]"
                :items="yesNo3"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect3($event, index)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[index].dt[2]"
                :items="yesNo4"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect4($event, index)"
              >
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { yesNo2, yesNo3, yesNo4, water } from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data", "title"],
  components: {},
  data() {
    return {
      yesNo2: yesNo2,
      yesNo3: yesNo3,
      yesNo4: yesNo4,
      water: water,
    };
  },
  methods: {
    onSelect2: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[index].dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[index].dt[1] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect4: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[index].dt[2] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.row-data {
  width: 200px;
  height: 32px;
  text-align: center;
  vertical-align: middle;
}
.row-data-left {
  width: 200px;
  height: 32px;
  text-align: left;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 12px;
}
</style>